module.exports = __webpack_public_path__ + "static/media/flag.e7c253b1.svg";